import styled from 'styled-components';

export const OVPCardWrapper = styled.div`
  margin: 16px 0 0;
`;
